import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";

const Fallback = ({ code = "400", message = "An error occured" }) => {
  const navigate = useNavigate();
  return (
    <Grid
      container
      sx={{ height: "calc(100vh - 64px)" }}
      justifyContent="center"
      alignItems="center"
    >
      <Grid item xs="auto">
        <Stack spacing={2}>
          <Stack
            direction="row"
            spacing={2}
            divider={<Divider orientation="vertical" flexItem />}
          >
            <Typography variant="h5">{code}</Typography>
            <Typography variant="h6">{message}</Typography>
          </Stack>
          <Button
            variant="outlined"
            onClick={() => {
              navigate("/");
            }}
          >
            Back to Home Page
          </Button>
        </Stack>
      </Grid>
    </Grid>
  );
};

const Unauthorized = () => {
  return <Fallback code="401" message="Unauthorized action." />;
};

const NotFound = () => {
  return <Fallback code="404" message="Not found." />;
};

export { Fallback, Unauthorized, NotFound };
